const notificationTab: Record<string, string> = {
  chat: 'chat',
  fixtures: 'fixtures',
  attendance: 'fixtures',
  results: 'results',
  polls: 'home',
};

export const notificationDataToAppRoute = (data: Record<string, string>): string | null => {
  let extraData: Record<string, unknown> = {};
  if (data.data) {
    try {
      const parsed = JSON.parse(data.data);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) extraData = parsed;
    } catch {
      extraData = {};
    }
  }
  const requestId = data.requestId || (typeof extraData.requestId === 'string' ? extraData.requestId : undefined);
  if ((data.type === 'diaryAttendance' || data.type === 'diaryAttendanceResponse') && requestId) {
    return `/diary-attendance/${encodeURIComponent(requestId)}`;
  }

  const teamIdentifier = data.teamName || data.teamUid || data.teamUuid;
  if (!teamIdentifier) return null;

  const teamSlug = encodeURIComponent(teamIdentifier.trim().replace(/\s+/g, '_'));
  const tab = notificationTab[data.type] || 'home';
  return `/team/${teamSlug}/${tab}`;
};